"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisSeverity = void 0;
// eslint-disable-next-line import/prefer-default-export, no-shadow
var AnalysisSeverity;
(function (AnalysisSeverity) {
    AnalysisSeverity[AnalysisSeverity["info"] = 1] = "info";
    AnalysisSeverity[AnalysisSeverity["warning"] = 2] = "warning";
    AnalysisSeverity[AnalysisSeverity["critical"] = 3] = "critical";
})(AnalysisSeverity || (exports.AnalysisSeverity = AnalysisSeverity = {}));
//# sourceMappingURL=analysis-options.interface.js.map